// extracted by mini-css-extract-plugin
export default {"activeCategory":"activeCategory__Cug8s","categoriesList":"categoriesList__OeVV3"};